import angular from 'angular';
import { OrderHistoryListComponent } from './order-history-list.component';
import { DropdownToggleMouseover } from './dropdown-toggle-mouseover';
import paging from '../../../../../components/paging';
export var OrderHistoryListModule = angular
    .module('directives.orderHistoryList', [
    paging
])
    .component('orderHistoryList', OrderHistoryListComponent)
    .directive('dropdownToggleMouseover', DropdownToggleMouseover)
    .name;
//# sourceMappingURL=order-history-list.module.js.map